import {
  AuthorizationRequest,
  AuthorizationServiceConfiguration,
  AuthorizationNotifier,
  RedirectRequestHandler,
  TokenRequest,
  GRANT_TYPE_AUTHORIZATION_CODE,
  BaseTokenRequestHandler,
  FetchRequestor,
  GRANT_TYPE_REFRESH_TOKEN,
  LocalStorageBackend,
  DefaultCrypto,
  RevokeTokenRequest

} from "@openid/appauth";

import { oauth_dev } from '../constants';
import NoHashQueryStringUtils from './noHashQueryStringUtils';
import { jwtDecode } from "jwt-decode";
import apis from '../dal';

export const authflow = (function () {
  let authorizationHandler = null;
  let updateStateValuesFn = null;

  function initAuthorizationHandler() {
    authorizationHandler = new RedirectRequestHandler(
      new LocalStorageBackend(),
      new NoHashQueryStringUtils(),
      window.location,
      new DefaultCrypto()
    );
  };

  function setStateValues(callbackFunction) {
    updateStateValuesFn = callbackFunction;
  }

  async function setAuthorizationHandler(navigatgeTo) {
    let notifier = new AuthorizationNotifier();
    let tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());

    authorizationHandler.setAuthorizationNotifier(notifier);
    notifier.setAuthorizationListener((request, response, error) => {
      console.log('Authorization request complete ', request, response, error);
      if (response) {
        console.log(`Authorization Code  ${response.code}`);

        let extras = null;
        if (request && request.internal) {
          extras = {};
          extras.code_verifier = request.internal.code_verifier;
          extras.scope = oauth_dev.scope;
          extras.client_secret = oauth_dev.clientSecret;
        }

        const tokenRequest = new TokenRequest({
          client_id: oauth_dev.clientId,
          redirect_uri: oauth_dev.redirectURL,
          grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
          code: response.code,
          refresh_token: undefined,
          extras,
        });

        const tokenResponse = AuthorizationServiceConfiguration.fetchFromIssuer(oauth_dev.OPServer, new FetchRequestor())
          .then(oResponse => {
            const configuration = oResponse;
            storeConfiguaration(oResponse);
            return tokenHandler.performTokenRequest(configuration, tokenRequest);
          })
          .then(oResponse => {
            storeTokens(oResponse);
            console.log('oResponse --' + oResponse);
            const resp = { status: 'success' };
            updateStateValuesFn(resp);
            localStorage.removeItem("loginurlpath");
            navigatgeTo();
          })
          .catch(oError => {
            console.log(oError);
            localStorage.removeItem("loginurlpath");
            const resp = { status: 'failure' };
            updateStateValuesFn(resp);
          });
      }
    });
    const response = await authorizationHandler.completeAuthorizationRequestIfPossible();
    console.log("response", response);
    return response;
  };

  const fetchServiceConfiguration = async () => {
    const response = await AuthorizationServiceConfiguration.fetchFromIssuer(
      oauth_dev.OPServer,
      new FetchRequestor()
    );
    response.authorizationEndpoint = response.authorizationEndpoint+"/okta";
    console.log('Fetched service configuration', response);
    return response;
  };

  function makeAuthorizationRequest(configuration) {
    if (!configuration) {
      console.log('Unknown service configuration');
      return;
    }

    const extras = { prompt: 'consent', access_type: 'offline' };
    // create a request
    const request = new AuthorizationRequest(
      {
        client_id: oauth_dev.clientId,
        redirect_uri: oauth_dev.redirectURL,
        scope: oauth_dev.scope,
        response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
        state: undefined,
        extras: extras,
      }
    );
    console.log('Making authorization request ', configuration, request);
    authorizationHandler.performAuthorizationRequest(configuration, request);
  };

  return {
    initAuthorizationHandler,
    fetchServiceConfiguration,
    makeAuthorizationRequest,
    setAuthorizationHandler,
    setStateValues
  };
})();

const tokenStorage = "token-storage";
export const LOGIN_TIMEOUTS = {
  TOKEN_REFRESH_INTERVAL: 180,
  USER_INACTIVITY_TIMEOUT: 5,
  USER_AUTO_LOGOUT: 5,
};
const storeTokens = (response) => {
  const tToken = response.idToken;
  const idToken = {
    value: response.idToken,
    claims: jwtDecode(tToken),
    idToken: response.idToken,
  };
  const accessToken = {
    value: response.accessToken,
    claims: jwtDecode(response.accessToken),
    accessToken: response.accessToken,
  };

  const token = {
    idToken,
    accessToken,
    expiresIn: response.expiresIn,
    issuedAt: response.issuedAt,
    refreshToken: response.refreshToken,
    tokenResponse: response,
  };
  localStorage.setItem(tokenStorage, JSON.stringify(token));
};

function storeConfiguaration(config) {
  localStorage.setItem("configurations", JSON.stringify(config));
}

function getConfiguration() {
  const jsonData = localStorage.getItem("configurations");
  const configurations = JSON.parse(jsonData);
  return configurations;
}

function removeConfiguration() {
  localStorage.removeItem("configurations");
}

// export async function signOut(event) {
//   const tokenDetails = getTokenDetails();
//   const idToken = tokenDetails ? tokenDetails.idToken.idToken : null;
//   const accessToken = tokenDetails ? tokenDetails.accessToken.accessToken : null;
//   removeConfiguration();
//   clearTokens();
//   event.preventDefault();
//   if (accessToken) {
//     await apis.revokeAccessRequest(oauth_dev.OPServer, accessToken)
//       .then(res => console.log('Revoke token response: ' + res))
//       .catch(err => {
//         console.log('Revode token reqiest' + err);
//       });
//   }
//   const signouturi = window.location.origin;
//   window.location.href = `${oauth_dev.OPServer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${encodeURIComponent(signouturi)}`;
// }

export async function signOut() {
  localStorage.clear();
  window.location.reload();
}

export const clearTokens = () => {
  const jsonData = localStorage.getItem(tokenStorage);
  const tokenDetails = JSON.parse(jsonData);
  if (tokenDetails) {
    localStorage.removeItem(tokenStorage);
  }
};

export const storeLoginUrlPath = (pathname) => {
  if(pathname === '/ROS/internal/equinor'){
    localStorage.setItem("loginurlpath", "/ROS/internal/equinor");
  }
};

export const getTokenValidity = () => {
  const jsonData = localStorage.getItem(tokenStorage);
  const tokenDetails = JSON.parse(jsonData);
  const currentTime = Math.floor(new Date().getTime() / 1000.0);
  if (tokenDetails) {
    const tokenExpiresIn = tokenDetails.issuedAt + tokenDetails.expiresIn;
    const diff =
      (tokenExpiresIn -
        LOGIN_TIMEOUTS.TOKEN_REFRESH_INTERVAL -
        currentTime) *
      1000;
    return diff;
  } else {
    return null;
  }
};

export const getTokenDetails = () => {
  const jsonData = localStorage.getItem(tokenStorage);
  const tokenDetails = JSON.parse(jsonData);
  return tokenDetails;
}

export const isTokenExpired = () => {
  let isExpired = false;
  const jsonData = localStorage.getItem('token-storage');
  const tokenDetails = JSON.parse(jsonData);
  const tokenExpiresAt = tokenDetails ? tokenDetails.accessToken.claims.exp : 0;
  if (tokenExpiresAt - Math.floor(Date.now() / 1000) <= 0) {
    isExpired = true;
  }
  return isExpired;
};

export const createTokenRequest = () => {
  return new BaseTokenRequestHandler(new FetchRequestor());
};

export const fetchServiceConfigurationRefresh = (refreshToken, tokenHandler, setAccessTokenFn) => {
  AuthorizationServiceConfiguration.fetchFromIssuer(
    oauth_dev.OPServer,
    new FetchRequestor()
  ).then((response) => {
    const configuration = response;
    let request = null;
    const extras = {
      scope: oauth_dev.scope,
      client_secret: oauth_dev.clientSecret
    };

    request = new TokenRequest({
      client_id: oauth_dev.clientId,
      redirect_uri: oauth_dev.redirectURL,
      grant_type: GRANT_TYPE_REFRESH_TOKEN,
      code: undefined,
      refresh_token: refreshToken,
      extras,
    });
    refreshTokenRequest(request, configuration, tokenHandler, setAccessTokenFn);
  }).catch((error) => {
    console.log("Error", error);
  });
}

const refreshTokenRequest = (request, configuration, tokenHandler, setAccessTokenFn) => {
  tokenHandler.performTokenRequest(configuration, request).then((response) => {
    storeTokens(response);
    setAccessTokenFn(response.accessToken);
    //setTimeout(() =>{ fetchServiceConfigurationRefresh(response.refreshToken,tokenHandler) }, diff);

  }).catch((error) => {
    console.log("RefreshTokenRequest :", error);
  });
}
